
export const MOCK_LOGIN = "MOCK_LOGIN";
export const MOCK_DASHBOARD_LIST = "MOCK_DASHBOARD_LIST";


export const Test = "test";
export const LOGGED_IN_DATA = "LOGGED_IN_DATA";
export const AUTH_DATA = "AUTH_DATA";
export const APPOINTMENT_AUTH_DATA="APPOINTMENT_AUTH_DATA";
